<template>
  <div class="popular">
    <div class="popularbox">
      <div class="populartop">热门资源</div>
      <div class="popularmetter" v-if="popular.length!==0">
        <div class="populardata" v-for="(item,index) in popular" :key="index" v-show="index<9">
          <div>
            <img :src="item.imgurl" alt style="cursor: pointer;" @click="videolearn(item.id)" />
          </div>
          <div>
            <div>{{item.name}}</div>
            <div style="font-size:12px">
              <div>观看：{{item.visitnum}}</div>
              <div>点赞：{{item.assistcount}}</div>
            </div>
          </div>
        </div>
      </div>
      <nodata v-else></nodata>
      <!-- <div class="popularfooter">
                <el-button type="primary" plain>查看更多</el-button>
      </div>-->
    </div>
  </div>
</template>
<script>
import * as resourceInfo from '@/api/resources/index.js';
export default {
  data() {
    return {
      popular: [],
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    getlist() {
     
      resourceInfo.DocumentHotDocmentList(10).then((res) => {
        this.popular = res.result;
      });
    },
    videolearn(id) {
      resourceInfo.DocumentRead(id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: id,
        },
      });
      location.reload();
    },
  },
};
</script>
<style scoped>
.popular {
  width: 300px;
  /* height: 1050px; */
}
/* 标题样式 */
.populartop {
  height: 57px;
  line-height: 57px;
  padding-left: 8px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #555;
  border-bottom: solid 1px #f2f2f2;
}
.popularmetter {
  /* height: 875px; */
  /* background: blue; */
  margin-top: 8px;
}
/* 单个数据 */
.populardata {
  width: 300px;
  height: 100px;
  background-color: #fff;
  display: flex;
}
/* 图片 */
.populardata > div:nth-child(1) {
  width: 130px;
  height: 100px;
}
.populardata > div:nth-child(1) > img {
  margin-left: 10px;
  margin-top: 15px;
  width: 110px;
  height: 70px;
}

/* 内容 */
.populardata > div:nth-child(2) {
  width: 170px;
  height: 100px;
}
.populardata > div:nth-child(2) > div:nth-child(1) {
  width: 150px;
  font-size: 14px;
  margin-top: 15px;
  font-kerning: normal;
  color: #555555;
}
.populardata > div:nth-child(2) > div:nth-child(2) {
  width: 150px;
  font-size: 14px;
  margin-top: 15px;
  font-kerning: normal;
  display: flex;
  justify-content: space-around;

  color: #555555;
}
.populardata > div:nth-child(2) > div:nth-child(2) > div {
  flex: 1;
  color: #888;
}
.popularfooter {
  margin-left: 100px;
  margin-top: 40px;
}
</style>